"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.kararSchema = exports.gundemKaynagiSchema = exports.katilimSatiriSchema = exports.yeterSayiSchema = exports.kurulListeSuzgeciSchema = exports.kurulListesiSchema = exports.kurulDetaySchema = exports.kurulUyeAdayiSchema = exports.kurulYetkileriSchema = exports.olaganustuOnerisiSchema = exports.kurulOzetiSchema = exports.kurulUyesiSchema = exports.toplantiKapatSchema = exports.kararDofAcSchema = exports.kararDuzeltSchema = exports.kararOlusturSchema = exports.KURUL_ILAN_GORUSULDU_MESAJI = exports.KURUL_KARAR_BOS_MESAJI = exports.katilimYazSchema = exports.toplantiDuzeltSchema = exports.toplantiPlanlaSchema = exports.gundemMaddesiOlusturSchema = exports.kurulGuncelleSchema = exports.kurulOlusturSchema = exports.KURUL_OLAGANUSTU_ONERI_PENCERE_GUN = exports.KURUL_OLAGANUSTU_ONERI_SIDDET_SIRA = exports.KURUL_DAVET_SAATI = exports.KURUL_SIKLIK_TAVANI_AY = exports.KURUL_ZORUNLU_CALISAN_ESIGI = exports.KURUL_TOPLANTI_TAKIP_ONEKI = exports.KURUL_UYE_ROL_ETIKETI = exports.KURUL_UYE_ROLLERI = exports.KURUL_KARAR_SONUC_ETIKETI = exports.KURUL_TOPLANTI_DURUM_ETIKETI = exports.KURUL_PLANLAMA_NOTU_MAX = exports.KURUL_GUNDEM_OTOMATIK_ETIKETI = exports.KURUL_GUNDEM_ILK_SIRA = exports.KURUL_KACINMA_TEBLIG_METNI = exports.KURUL_KACINMA_TALEBI_ETIKETI = exports.KURUL_TOPLANTI_TIP_ETIKETI = exports.KURUL_UYE_TIPI_ETIKETI = exports.KURUL_KARAR_SONUCLARI = exports.kurulToplantiDurumuSchema = exports.KURUL_TOPLANTI_DURUMLARI = exports.kurulToplantiTipiSchema = exports.KURUL_TOPLANTI_TIPLERI = exports.kurulSekreterTipiSchema = exports.KURUL_SEKRETER_TIPLERI = exports.kurulUyeTipiSchema = exports.KURUL_UYE_TIPLERI = void 0;
exports.gundemSecenekleriSchema = exports.kurulSecenekleriSchema = exports.toplantiListeSuzgeciSchema = exports.toplantiListesiSchema = exports.toplantiDetaySchema = exports.toplantiOzetiSchema = exports.toplantiYetkileriSchema = exports.toplantiEkiSchema = exports.toplantiLogSatiriSchema = exports.oncekiKararDurumuSchema = exports.gundemMaddesiSchema = void 0;
exports.kurulKararSonucu = kurulKararSonucu;
exports.kurulZorunluMu = kurulZorunluMu;
exports.kurulSiklikTavaniAy = kurulSiklikTavaniAy;
exports.kurulSiklikIhlalleri = kurulSiklikIhlalleri;
exports.kurulSonrakiVade = kurulSonrakiVade;
exports.kurulGecikmeGunu = kurulGecikmeGunu;
exports.yeterSayi = yeterSayi;
exports.uyelikYururlukteMi = uyelikYururlukteMi;
exports.uyeRolu = uyeRolu;
exports.toplantiYazilabilirMi = toplantiYazilabilirMi;
exports.kirkSekizSaatUyarisi = kirkSekizSaatUyarisi;
exports.kurulKarariAcikMi = kurulKarariAcikMi;
exports.toplantiSuzgecOzeti = toplantiSuzgecOzeti;
const zod_1 = require("zod");
const egitim_1 = require("./egitim");
const kapi_durumu_1 = require("./kapi-durumu");
const vade_1 = require("./vade");
/**
 * İSG KURULU — KURAL VE SÖZLEŞME KATMANI (Kapsam §28; ERD §10h —
 * 05.09.2026; sertleştirme programı sonrası İKİNCİ yapım turu).
 *
 * ════════════════════════════════════════════════════════════════════════
 * TURUN TEK CÜMLESİ: ÜYELİK GÖREVLENDİRMEDİR, TOPLANTI KAYITTIR, KARAR DÖF'TÜR
 * ════════════════════════════════════════════════════════════════════════
 *
 * Bu dosyadaki her yüklemin TEK okuyucu ailesi vardır (§2.40 — kapı ile
 * görünürlük aynı cümleden):
 *   kurulZorunluMu          — C1: ≥50 çalışan ∧ kısa süreli iş işareti yok
 *   KURUL_SIKLIK_TAVANI_AY  — C4: sınıf tavanı (#11 kademesiyle AYNI sayılar)
 *   kurulSiklikIhlalleri    — C4: yazma anında 422
 *   kurulSonrakiVade        — C4: son yapılan olağan + sıklık (kolon yok)
 *   yeterSayi               — C3: salt çoğunluk (karar kapısı VE kapanış)
 *   uyeRolu                 — C2: başkan/sekreter türetilir
 *   kirkSekizSaatUyarisi    — C5: kapı değil, uyarı
 *   toplantiYazilabilirMi   — C3: tek yön durum
 */
// ── Enum'lar (İngilizce token — §10) ─────────────────────────────────────
exports.KURUL_UYE_TIPLERI = [
    'isveren_vekili',
    'isg_uzmani',
    'isyeri_hekimi',
    'ik_idari',
    'sivil_savunma',
    'formen_usta',
    'calisan_temsilcisi',
];
exports.kurulUyeTipiSchema = zod_1.z.enum(exports.KURUL_UYE_TIPLERI);
/** Sekreter yalnız uzman ya da İK/idari (C2 — DB CHECK'in kural yarısı). */
exports.KURUL_SEKRETER_TIPLERI = ['isg_uzmani', 'ik_idari'];
exports.kurulSekreterTipiSchema = zod_1.z.enum(exports.KURUL_SEKRETER_TIPLERI);
/**
 * ✏️ 07.09.2026 (G3.3 — ürün sahibi onayı 06.09): tip İKİYE indi; kaçınma hakkı
 * artık olağanüstü toplantının **işaretidir** (`kacinmaTalebi`). İşaret varsa
 * tebliğ akışı (md.9/3) ve PDF tebliğ bloğu korunur.
 */
exports.KURUL_TOPLANTI_TIPLERI = ['olagan', 'olaganustu'];
exports.kurulToplantiTipiSchema = zod_1.z.enum(exports.KURUL_TOPLANTI_TIPLERI);
exports.KURUL_TOPLANTI_DURUMLARI = ['planlandi', 'yapildi', 'yapilamadi'];
exports.kurulToplantiDurumuSchema = zod_1.z.enum(exports.KURUL_TOPLANTI_DURUMLARI);
/**
 * T2 (türetme paketi — bulgu 52, 17.09.2026; Kapsam §14 T2 · §28.1 C7 ✏️):
 * KARAR SONUCU SAKLANMAZ, KARAR METNİNDEN TÜRETİLİR. Metin varsa *alındı*,
 * yoksa *görüşüldü* — "teklif reddedildi" da bir karar metnidir. Eski
 * `alindi` / `reddedildi` kolonu düştü (aynı soruya ikinci cevap kaynağıydı).
 * DÖF kapısı, ilan işareti, ekran rozeti ve tutanak AYNI yüklemi okur.
 */
exports.KURUL_KARAR_SONUCLARI = ['alindi', 'gorusuldu'];
function kurulKararSonucu(karar) {
    return karar.kararMetni !== null && karar.kararMetni.trim() !== '' ? 'alindi' : 'gorusuldu';
}
/** Ekran, PDF ve bildirim AYNI haritayı okur (D2 — enum ekrana inmez). */
exports.KURUL_UYE_TIPI_ETIKETI = {
    isveren_vekili: 'İşveren vekili',
    isg_uzmani: 'İSG uzmanı',
    isyeri_hekimi: 'İşyeri hekimi',
    ik_idari: 'İK / idari',
    sivil_savunma: 'Sivil savunma uzmanı',
    formen_usta: 'Formen / usta',
    calisan_temsilcisi: 'Çalışan temsilcisi',
};
exports.KURUL_TOPLANTI_TIP_ETIKETI = {
    olagan: 'Olağan',
    olaganustu: 'Olağanüstü',
};
/** G3.3 — işaretin ekran/PDF etiketi (tek kaynak). */
exports.KURUL_KACINMA_TALEBI_ETIKETI = 'Çalışmaktan kaçınma talebi';
/** G3.3 — tebliğ bloğu (md.9/3): karar çalışana ve çalışan temsilcisine yazılı tebliğ edilir. */
exports.KURUL_KACINMA_TEBLIG_METNI = 'Bu toplantı çalışmaktan kaçınma talebi üzerine toplanmıştır. Kurul kararı, talepte bulunan ' +
    'çalışana ve çalışan temsilcisine yazılı olarak tebliğ edilir.';
/**
 * G3.2 — GÜNDEM NUMARASI: 1. madde otomatiktir (önceki kararların durumu —
 * türetilir, saklanmaz); kayıtlı maddeler 2'den başlar (DB CHECK
 * `committee_agenda_item_sira_ikiden`). Planlama ekranı 1. maddeyi soluk
 * satır olarak gösterir — numara her yüzeyde aynı anlama gelir.
 */
exports.KURUL_GUNDEM_ILK_SIRA = 2;
exports.KURUL_GUNDEM_OTOMATIK_ETIKETI = 'Önceki kararların durumu — otomatik';
exports.KURUL_PLANLAMA_NOTU_MAX = 4000;
exports.KURUL_TOPLANTI_DURUM_ETIKETI = {
    planlandi: 'Planlandı',
    yapildi: 'Yapıldı',
    yapilamadi: 'Yapılamadı',
};
exports.KURUL_KARAR_SONUC_ETIKETI = {
    alindi: 'Alındı',
    gorusuldu: 'Görüşüldü',
};
exports.KURUL_UYE_ROLLERI = ['baskan', 'sekreter', 'uye'];
exports.KURUL_UYE_ROL_ETIKETI = {
    baskan: 'Başkan',
    sekreter: 'Sekreter',
    uye: 'Üye',
};
/** Takip numarası öneki — olay `OLY-` · uygunsuzluk `UYG-` · saha turu `STR-` · kurul `KRL-`. */
exports.KURUL_TOPLANTI_TAKIP_ONEKI = 'KRL-';
// ── C1 — ZORUNLULUK TÜRETİLİR ─────────────────────────────────────────────
/** Yönetmelik md.4: elli ve daha fazla çalışan. Sayı §3.2 sayımından gelir. */
exports.KURUL_ZORUNLU_CALISAN_ESIGI = 50;
/**
 * C1 — kurul bu işyerinde ZORUNLU mu? İkinci koşul (*altı aydan uzun iş*)
 * kural motoruna girmez: yükümlülük #10'un *"kısa süreli iş"* elle işareti
 * onu taşır (İ5 — işaretlenir, sorgulanır, engellenmez). Kolon yok.
 */
function kurulZorunluMu(girdi) {
    return girdi.calisanSayisi >= exports.KURUL_ZORUNLU_CALISAN_ESIGI && !girdi.kisaSureliIs;
}
// ── C4 — SIKLIK: SINIF TAVANI, TEK SABİT ──────────────────────────────────
/**
 * Yönetmelik md.9/1-a: az tehlikeli üç ayda bir · tehlikeli iki ayda bir ·
 * çok tehlikeli ayda bir. ⚠️ **SIRA az / tehlikeli / çok** (C4 artçısının
 * dersi) ve sayılar yükümlülük #11 kademesiyle **BİREBİR** — ikinci kopya
 * yazılmaz, `obligation-library-content` bu sabiti test eder.
 * Sıkılaştırma serbest (1 her sınıfta geçer), gevşetme tavana kadar.
 */
exports.KURUL_SIKLIK_TAVANI_AY = { az: 3, tehlikeli: 2, cok: 1 };
function kurulSiklikTavaniAy(tehlikeSinifi) {
    return exports.KURUL_SIKLIK_TAVANI_AY[(0, egitim_1.tehlikeSinifiAnahtari)(tehlikeSinifi)];
}
/**
 * C4 — yazma anındaki ihlaller (D2 dili; boş dizi = geçer). Gevşetme kurul
 * kararı notu ister: *"kurul kararıyla gevşetilebilir"* cümlesinin kayıt
 * karşılığı budur (hangi toplantının kararı — serbest metin).
 */
function kurulSiklikIhlalleri(girdi) {
    const ihlaller = [];
    const tavan = kurulSiklikTavaniAy(girdi.tehlikeSinifi);
    if (!Number.isInteger(girdi.siklikAy) || girdi.siklikAy < 1 || girdi.siklikAy > 3) {
        ihlaller.push('Toplantı sıklığı 1, 2 ya da 3 ay olabilir');
        return ihlaller;
    }
    if (girdi.siklikAy > tavan) {
        ihlaller.push(tavan === 1
            ? 'Çok tehlikeli işyerinde kurul ayda bir toplanır; sıklık gevşetilemez'
            : `Bu tehlike sınıfında toplantı sıklığı en çok ${tavan} ay olabilir`);
    }
    if (girdi.siklikAy > 1 && !(girdi.siklikKararNotu ?? '').trim()) {
        ihlaller.push('Sıklığı gevşetmek kurul kararı ister; kararın toplantısını yazın');
    }
    return ihlaller;
}
// ── C4 — VADE TÜRETİLİR ───────────────────────────────────────────────────
/** `YYYY-AA-GG` + n ay (UTC gün ekseni — G11). */
function ayEkle(gun, ay) {
    const d = new Date(`${gun}T00:00:00Z`);
    d.setUTCMonth(d.getUTCMonth() + ay);
    return d.toISOString().slice(0, 10);
}
/**
 * C4 — sonraki olağan toplantının vadesi: son YAPILMIŞ OLAĞAN toplantı +
 * sıklık; hiç yoksa kuruluş tarihi + sıklık. Olağanüstü toplantı vadeyi
 * İLERLETMEZ; planlanmış toplantı da ilerletmez (niyet ≠ olgu).
 */
function kurulSonrakiVade(girdi) {
    return ayEkle(girdi.sonOlaganToplantiTarihi ?? girdi.kurulusTarihi, girdi.siklikAy);
}
/** Gecikme günü — vade geçmişse pozitif, değilse 0 (C10). */
function kurulGecikmeGunu(vade, bugun) {
    // Madde 296 — gün farkı TEK YÜKLEMDEN (vade günü son gündür: o gün 0).
    return Math.max(0, -(0, vade_1.vadeyeKalanGun)(vade, bugun));
}
/**
 * C3 — üye tam sayısının SALT ÇOĞUNLUĞU: ⌊N/2⌋ + 1. N = toplantı tarihinde
 * yürürlükteki üyelik sayısı. Karar yazma kapısı VE kapanış bu fonksiyonu
 * çağırır; ekranın *"yeter sayı sağlanmadı"* cümlesi de buradan.
 * ⚠️ N = 0 (üyesi olmayan kurul) → sağlanmadı: boş kurul karar alamaz.
 */
function yeterSayi(uyeTamSayisi, katilan) {
    const saltCogunluk = Math.floor(uyeTamSayisi / 2) + 1;
    return {
        uyeTamSayisi,
        katilan,
        saltCogunluk,
        saglandi: uyeTamSayisi > 0 && katilan >= saltCogunluk,
    };
}
/** Üyelik toplantı TARİHİNDE yürürlükte mi (G1-c — kaldırılan üye o günkü listede durur). */
function uyelikYururlukteMi(uyelik, tarih) {
    if (uyelik.baslangicTarihi > tarih)
        return false;
    return uyelik.kaldirmaTarihi === null || uyelik.kaldirmaTarihi > tarih;
}
// ── C2 — ROL TÜRETİLİR ────────────────────────────────────────────────────
/** Başkan = işveren vekili (sabit); sekreter = kurulun seçtiği alt tip. */
function uyeRolu(uyeTipi, sekreterUyeTipi) {
    if (uyeTipi === 'isveren_vekili')
        return 'baskan';
    if (uyeTipi === sekreterUyeTipi)
        return 'sekreter';
    return 'uye';
}
// ── C3 — DURUM TEK YÖN ────────────────────────────────────────────────────
function toplantiYazilabilirMi(durum) {
    return durum === 'planlandi';
}
/**
 * C5 — 48 saat kuralı (md.9/1-b) KAPI DEĞİL UYARIDIR; olağanüstü ve kaçınma
 * toplantısında uyarı yoktur (acil toplantı 48 saat bekleyemez).
 */
exports.KURUL_DAVET_SAATI = 48;
function kirkSekizSaatUyarisi(girdi) {
    if (girdi.tip !== 'olagan')
        return false;
    const baslangic = Date.parse(`${girdi.tarih}T${girdi.baslangicSaat ?? '00:00'}:00Z`);
    return baslangic - girdi.simdi.getTime() < exports.KURUL_DAVET_SAATI * 3_600_000;
}
/**
 * C10 — açık karar = DÖF'ü CANLI olan karar. Canlı küme aksiyon modülünün
 * sabitidir (`AKSIYON_CANLI_DURUMLAR` — iptal düşer); çağıran onu verir,
 * bu dosya ikinci bir liste YAZMAZ (döngüsel import da doğmaz).
 */
function kurulKarariAcikMi(dofDurumu, canliDurumlar) {
    return dofDurumu !== null && canliDurumlar.includes(dofDurumu);
}
/**
 * C8 — olağanüstü toplantı ÖNERİSİ: gerçekleşen şiddeti bu basamak ve üstü
 * olan kaza (iş göremezlik / ölümlü — `sira` ekseni). Sistem önerir, karar
 * sahada — otomatik toplantı açılmaz.
 */
exports.KURUL_OLAGANUSTU_ONERI_SIDDET_SIRA = 4;
exports.KURUL_OLAGANUSTU_ONERI_PENCERE_GUN = 30;
// ── İstek şemaları ────────────────────────────────────────────────────────
const SAAT = zod_1.z.string().regex(/^([01][0-9]|2[0-3]):[0-5][0-9]$/, 'Saat SS:DD biçiminde olmalı');
exports.kurulOlusturSchema = zod_1.z.object({
    workplaceId: zod_1.z.uuid(),
    siklikAy: zod_1.z.number().int().min(1).max(3),
    siklikKararNotu: zod_1.z.string().trim().max(1000).nullable().optional(),
    sekreterUyeTipi: exports.kurulSekreterTipiSchema.default('isg_uzmani'),
    kurulusTarihi: zod_1.z.iso.date(),
});
exports.kurulGuncelleSchema = zod_1.z.object({
    siklikAy: zod_1.z.number().int().min(1).max(3).optional(),
    siklikKararNotu: zod_1.z.string().trim().max(1000).nullable().optional(),
    sekreterUyeTipi: exports.kurulSekreterTipiSchema.optional(),
});
exports.gundemMaddesiOlusturSchema = zod_1.z
    .object({
    baslik: zod_1.z.string().trim().min(1).max(500),
    siteTourId: zod_1.z.uuid().nullable().optional(),
    incidentId: zod_1.z.uuid().nullable().optional(),
    nonconformityId: zod_1.z.uuid().nullable().optional(),
})
    .superRefine((g, ctx) => {
    const dolu = [g.siteTourId, g.incidentId, g.nonconformityId].filter(Boolean).length;
    if (dolu > 1) {
        ctx.addIssue({ code: 'custom', message: 'Gündem maddesi en çok bir kaynak taşır' });
    }
});
exports.toplantiPlanlaSchema = zod_1.z
    .object({
    tip: exports.kurulToplantiTipiSchema.default('olagan'),
    /** G3.3 — yalnız olağanüstüde işaretlenir (superRefine + DB CHECK). */
    kacinmaTalebi: zod_1.z.boolean().default(false),
    tarih: zod_1.z.iso.date(),
    baslangicSaat: SAAT.nullable().optional(),
    bitisSaat: SAAT.nullable().optional(),
    yer: zod_1.z.string().trim().max(300).nullable().optional(),
    /** G3.4 — planlama notu; tutanak PDF'ine girer. */
    planlamaNotu: zod_1.z.string().trim().max(exports.KURUL_PLANLAMA_NOTU_MAX).nullable().optional(),
    gundem: zod_1.z.array(exports.gundemMaddesiOlusturSchema).max(50).default([]),
})
    .superRefine((g, ctx) => {
    if (g.kacinmaTalebi && g.tip !== 'olaganustu') {
        ctx.addIssue({
            code: 'custom',
            path: ['kacinmaTalebi'],
            message: 'Çalışmaktan kaçınma talebi yalnız olağanüstü toplantıda işaretlenir',
        });
    }
});
exports.toplantiDuzeltSchema = zod_1.z.object({
    tarih: zod_1.z.iso.date().optional(),
    baslangicSaat: SAAT.nullable().optional(),
    bitisSaat: SAAT.nullable().optional(),
    yer: zod_1.z.string().trim().max(300).nullable().optional(),
    /** G3.4 — planlama notu planlı toplantıda düzeltilebilir. */
    planlamaNotu: zod_1.z.string().trim().max(exports.KURUL_PLANLAMA_NOTU_MAX).nullable().optional(),
});
exports.katilimYazSchema = zod_1.z.object({
    katilanDesignationIds: zod_1.z.array(zod_1.z.uuid()).max(200),
});
/** Boş metin `null`dır — "yok" tek biçimde yaşar (DB CHECK `committee_decision_karar_metni_bos_degil`). */
const bosIseNull = zod_1.z
    .string()
    .trim()
    .max(4000)
    .nullable()
    .optional()
    .transform((v) => (v === undefined ? undefined : v === null || v === '' ? null : v));
/** T2 — satır bir şey söyler (karar metni ya da görüşme notu); ilan yalnız alınan karara. */
exports.KURUL_KARAR_BOS_MESAJI = 'Karar metni ya da görüşme notu yazın';
exports.KURUL_ILAN_GORUSULDU_MESAJI = 'Yalnız alınan karar ilan edilir — karar metnini yazın';
exports.kararOlusturSchema = zod_1.z
    .object({
    agendaItemId: zod_1.z.uuid(),
    gorusmeNotu: bosIseNull,
    kararMetni: bosIseNull,
    ilan: zod_1.z.boolean().default(false),
})
    .superRefine((g, ctx) => {
    if (!g.kararMetni && !g.gorusmeNotu) {
        ctx.addIssue({ code: 'custom', path: ['kararMetni'], message: exports.KURUL_KARAR_BOS_MESAJI });
    }
    if (g.ilan && kurulKararSonucu({ kararMetni: g.kararMetni ?? null }) !== 'alindi') {
        ctx.addIssue({ code: 'custom', path: ['ilan'], message: exports.KURUL_ILAN_GORUSULDU_MESAJI });
    }
});
/** D9 — kapalı tutanakta gerekçe ZORUNLU (serviste; açıkken isteğe bağlı). */
exports.kararDuzeltSchema = zod_1.z.object({
    gorusmeNotu: zod_1.z.string().trim().max(4000).nullable().optional(),
    kararMetni: bosIseNull,
    gerekce: zod_1.z.string().trim().max(1000).nullable().optional(),
});
/** Karar → DÖF (C7): kaynak SUNUCUDA "Kurul kararı"; istemci kaynak sormaz. */
exports.kararDofAcSchema = zod_1.z.object({
    baslik: zod_1.z.string().trim().min(1).max(300),
    aciklama: zod_1.z.string().trim().max(4000).nullable().optional(),
    atananAppUserId: zod_1.z.uuid(),
    terminTarihi: zod_1.z.iso.date(),
});
exports.toplantiKapatSchema = zod_1.z.object({
    sonuc: zod_1.z.enum(['yapildi', 'yapilamadi']),
    kapanisNotu: zod_1.z.string().trim().max(2000).nullable().optional(),
});
// ── Yanıt şemaları ────────────────────────────────────────────────────────
exports.kurulUyesiSchema = zod_1.z.object({
    designationId: zod_1.z.uuid(),
    personId: zod_1.z.uuid(),
    adSoyad: zod_1.z.string().min(1),
    uyeTipi: exports.kurulUyeTipiSchema,
    rol: zod_1.z.enum(exports.KURUL_UYE_ROLLERI),
    baslangicTarihi: zod_1.z.iso.date(),
    /** Görevlendirme motorunun türetmesi (G5) — kurul hesaplamaz, gösterir. */
    eksik: zod_1.z.boolean(),
    eksikSartlar: zod_1.z.array(zod_1.z.string()),
    /** Hesabı var mı — davet/tebliğ alıcısı olabilir mi (Y6 sınırı görünür). */
    hesapVar: zod_1.z.boolean(),
});
exports.kurulOzetiSchema = zod_1.z.object({
    /** Kurul yoksa null — satır yine döner (işyeri ekseni, C1). */
    id: zod_1.z.uuid().nullable(),
    workplaceId: zod_1.z.uuid(),
    workplaceAd: zod_1.z.string().min(1),
    companyAd: zod_1.z.string().min(1),
    tehlikeSinifi: zod_1.z.enum(['low_risk', 'hazardous', 'highly_hazardous']),
    calisanSayisi: zod_1.z.number().int().nonnegative(),
    /** C1 — TÜRETİLİR. */
    zorunlu: zod_1.z.boolean(),
    kisaSureliIs: zod_1.z.boolean(),
    siklikAy: zod_1.z.number().int().nullable(),
    sekreterUyeTipi: exports.kurulSekreterTipiSchema.nullable(),
    kurulusTarihi: zod_1.z.iso.date().nullable(),
    uyeSayisi: zod_1.z.number().int().nonnegative(),
    eksikUyeSayisi: zod_1.z.number().int().nonnegative(),
    /** C10 — TÜRETİLİR. */
    sonOlaganToplantiTarihi: zod_1.z.iso.date().nullable(),
    sonrakiVade: zod_1.z.iso.date().nullable(),
    gecikmeGunu: zod_1.z.number().int().nonnegative(),
    acikKararSayisi: zod_1.z.number().int().nonnegative(),
    planliToplantiSayisi: zod_1.z.number().int().nonnegative(),
});
exports.olaganustuOnerisiSchema = zod_1.z.object({
    incidentId: zod_1.z.uuid(),
    takipNo: zod_1.z.string().min(1),
    olayTarihi: zod_1.z.iso.date(),
    siddetSira: zod_1.z.number().int(),
});
exports.kurulYetkileriSchema = zod_1.z.object({
    yazabilir: zod_1.z.boolean(),
    /** G3.1 — kurul sayfasından üye ekleme: görevlendirme yazma şapkası ∧ bahçe (sunucudan). */
    uyeEkleyebilir: zod_1.z.boolean(),
    /** P13 — kurul yazma kapısı (şapka → kurulun işyeri bahçesi → arşiv) + sebep. */
    yazmaKapisi: kapi_durumu_1.kapiDurumuSchema,
    /**
     * P13 — üye ekleme = GÖREVLENDİRME UCUNUN kapısı (şapka → KİŞİ bahçesi).
     * ⚠️ Arşiv adımı YOK: görevlendirme ucunda arşiv kapısı yoktur (istihdam deseni).
     */
    uyeEklemeKapisi: kapi_durumu_1.kapiDurumuSchema,
});
/**
 * G3.1 — kurul sayfasından üye ekleme ADAYI: işyerinin aktif istihdamlı,
 * henüz kurul üyesi OLMAYAN kişisi. Ekleme AYNI görevlendirme kaydını yazar
 * (`POST persons/:id/designations` + `kurulUyeTipi`) — ikinci üye tablosu yok.
 */
exports.kurulUyeAdayiSchema = zod_1.z.object({
    personId: zod_1.z.uuid(),
    employmentId: zod_1.z.uuid(),
    adSoyad: zod_1.z.string().min(1),
});
exports.kurulDetaySchema = exports.kurulOzetiSchema.extend({
    siklikKararNotu: zod_1.z.string().nullable(),
    siklikTavaniAy: zod_1.z.number().int(),
    uyeler: zod_1.z.array(exports.kurulUyesiSchema),
    /** G3.1 — soluk satırın kişi listesi (sunucudan; bahçe + aktif istihdam). */
    uyeAdaylari: zod_1.z.array(exports.kurulUyeAdayiSchema),
    /** "Kurul üyesi" görevlendirme türünün NÜSHA kimliği — soluk satır bunu yazar; sözlükte yoksa null. */
    uyelikTuruId: zod_1.z.uuid().nullable(),
    /** C8 — sistem önerir, karar sahada. */
    olaganustuOnerileri: zod_1.z.array(exports.olaganustuOnerisiSchema),
    yetkiler: exports.kurulYetkileriSchema,
});
exports.kurulListesiSchema = zod_1.z.object({
    satirlar: zod_1.z.array(exports.kurulOzetiSchema),
    toplam: zod_1.z.number().int().nonnegative(),
    sayfa: zod_1.z.number().int().positive(),
    sayfaBoyutu: zod_1.z.number().int().positive(),
});
exports.kurulListeSuzgeciSchema = zod_1.z.object({
    workplaceId: zod_1.z.uuid().optional(),
    /** `kurullu` · `kurulsuz` · `zorunlu` (kurulsuz ve zorunlu — kırmızı). */
    durum: zod_1.z.enum(['kurullu', 'kurulsuz', 'zorunlu']).optional(),
    sayfa: zod_1.z.coerce.number().int().positive().default(1),
    sayfaBoyutu: zod_1.z.coerce.number().int().positive().max(100).default(25),
});
exports.yeterSayiSchema = zod_1.z.object({
    uyeTamSayisi: zod_1.z.number().int().nonnegative(),
    katilan: zod_1.z.number().int().nonnegative(),
    saltCogunluk: zod_1.z.number().int().nonnegative(),
    saglandi: zod_1.z.boolean(),
});
exports.katilimSatiriSchema = zod_1.z.object({
    designationId: zod_1.z.uuid(),
    personId: zod_1.z.uuid(),
    adSoyad: zod_1.z.string().min(1),
    uyeTipi: exports.kurulUyeTipiSchema,
    rol: zod_1.z.enum(exports.KURUL_UYE_ROLLERI),
    katildi: zod_1.z.boolean(),
});
exports.gundemKaynagiSchema = zod_1.z.object({
    tip: zod_1.z.enum(['saha_turu', 'olay', 'uygunsuzluk']),
    id: zod_1.z.uuid(),
    takipNo: zod_1.z.string().min(1),
});
exports.kararSchema = zod_1.z.object({
    id: zod_1.z.uuid(),
    agendaItemId: zod_1.z.uuid(),
    gorusmeNotu: zod_1.z.string().nullable(),
    /** T2 — null = görüşüldü; sonuç `kurulKararSonucu`ndan türetilir, yanıtta taşınmaz. */
    kararMetni: zod_1.z.string().min(1).nullable(),
    ilan: zod_1.z.boolean(),
    actionId: zod_1.z.uuid().nullable(),
    /** DÖF durumu (aksiyon modülü) — bağsız kararda null. */
    dofDurumu: zod_1.z.string().nullable(),
    dofBaslik: zod_1.z.string().nullable(),
    dofTermin: zod_1.z.iso.date().nullable(),
    /** C10 — DÖF canlı mı (`AKSIYON_CANLI_DURUMLAR`). */
    acik: zod_1.z.boolean(),
    createdAt: zod_1.z.iso.datetime(),
});
exports.gundemMaddesiSchema = zod_1.z.object({
    id: zod_1.z.uuid(),
    sira: zod_1.z.number().int().nonnegative(),
    baslik: zod_1.z.string().min(1),
    kaynak: exports.gundemKaynagiSchema.nullable(),
    kararlar: zod_1.z.array(exports.kararSchema),
});
/** C6 — otomatik #1: önceki toplantının DÖF'lü kararları, güncel DÖF durumuyla. TÜRETİLİR. */
exports.oncekiKararDurumuSchema = zod_1.z.object({
    kararId: zod_1.z.uuid(),
    kararMetni: zod_1.z.string().min(1),
    toplantiTakipNo: zod_1.z.string().min(1),
    toplantiTarihi: zod_1.z.iso.date(),
    actionId: zod_1.z.uuid(),
    dofBaslik: zod_1.z.string(),
    dofDurumu: zod_1.z.string(),
    dofTermin: zod_1.z.iso.date().nullable(),
    acik: zod_1.z.boolean(),
});
exports.toplantiLogSatiriSchema = zod_1.z.object({
    id: zod_1.z.uuid(),
    islem: zod_1.z.string(),
    gerekce: zod_1.z.string().nullable(),
    detay: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()).nullable(),
    aktorEtiket: zod_1.z.string().nullable(),
    createdAt: zod_1.z.iso.datetime(),
});
exports.toplantiEkiSchema = zod_1.z.object({
    id: zod_1.z.uuid(),
    dosyaAdi: zod_1.z.string().min(1),
    mimeType: zod_1.z.string().min(1),
    boyutBytes: zod_1.z.number().int().positive(),
    createdAt: zod_1.z.iso.datetime(),
    /**
     * P13-c (madde 227) — nüsha SİLME kapısı SATIR BAŞINA: kurul yazma adımları
     * → KAPALI TOPLANTI (durum kilidi, holding dahil) → sahiplik (yükleyen VEYA
     * holding yön.). ⚠️ Nüsha yalnız kapalı toplantıya yüklenir (C9) → yüklenen
     * nüsha kalıcıdır; ekran sebebi bir kez yazar, düğme hiç çizilmez.
     */
    silmeKapisi: kapi_durumu_1.kapiDurumuSchema,
});
exports.toplantiYetkileriSchema = zod_1.z.object({
    /** planlandi ∧ şapka ∧ bahçe. */
    yazabilir: zod_1.z.boolean(),
    /** Kapalı tutanakta D9 düzeltme: şapka ∧ bahçe (yazabilir'den bağımsız). */
    duzeltebilir: zod_1.z.boolean(),
    /** Karar yazılabilir mi — yeter sayı (C3). */
    kararYazilabilir: zod_1.z.boolean(),
    kararEngeli: zod_1.z.string().nullable(),
    /** `yapildi` kapanışı — yeter sayı sağlanmalı. */
    yapildiKapatilabilir: zod_1.z.boolean(),
    kapanisEngeli: zod_1.z.string().nullable(),
    /** İmzalı nüsha yükleme — yalnız kapalı toplantıya. */
    ekYukleyebilir: zod_1.z.boolean(),
    /** P13 — kurul yazma kapısı + sebep (planlama / katılım / gündem / karar bölümleri). */
    yazmaKapisi: kapi_durumu_1.kapiDurumuSchema,
    /** P13 — karar → DÖF: kurul yazma kapısı + İSG ekibi anahtarı (`uzman_aksiyon_atama`). */
    dofKapisi: kapi_durumu_1.kapiDurumuSchema,
    /**
     * Madde 230 — kapalı toplantıda nüsha silmek GEREKÇE ister (yalnız holding
     * yön. silebilir; gerekçesiz 422). Ekran gerekçe alanını bundan çizer —
     * "kapalı mı" kuralını yeniden yazmaz.
     */
    nushaSilmeGerekceZorunlu: zod_1.z.boolean(),
});
exports.toplantiOzetiSchema = zod_1.z.object({
    id: zod_1.z.uuid(),
    committeeId: zod_1.z.uuid(),
    takipNo: zod_1.z.string().min(1),
    tip: exports.kurulToplantiTipiSchema,
    /** G3.3 — olağanüstü + çalışmaktan kaçınma talebi işareti. */
    kacinmaTalebi: zod_1.z.boolean(),
    /** G3.4 — planlama notu. */
    planlamaNotu: zod_1.z.string().nullable(),
    durum: exports.kurulToplantiDurumuSchema,
    tarih: zod_1.z.iso.date(),
    baslangicSaat: zod_1.z.string().nullable(),
    bitisSaat: zod_1.z.string().nullable(),
    yer: zod_1.z.string().nullable(),
    workplaceId: zod_1.z.uuid(),
    workplaceAd: zod_1.z.string().min(1),
    companyAd: zod_1.z.string().min(1),
    yeterSayi: exports.yeterSayiSchema,
    gundemSayisi: zod_1.z.number().int().nonnegative(),
    kararSayisi: zod_1.z.number().int().nonnegative(),
    acikKararSayisi: zod_1.z.number().int().nonnegative(),
    kapanisAt: zod_1.z.iso.datetime().nullable(),
    kapanisNotu: zod_1.z.string().nullable(),
    planlayanEtiket: zod_1.z.string().min(1),
    createdAt: zod_1.z.iso.datetime(),
});
exports.toplantiDetaySchema = exports.toplantiOzetiSchema.extend({
    katilim: zod_1.z.array(exports.katilimSatiriSchema),
    /** C6 — #1 türetilmiş; boş dizi = önceki toplantı yok ya da DÖF'lü karar yok. */
    oncekiKararlar: zod_1.z.array(exports.oncekiKararDurumuSchema),
    gundem: zod_1.z.array(exports.gundemMaddesiSchema),
    log: zod_1.z.array(exports.toplantiLogSatiriSchema),
    ekler: zod_1.z.array(exports.toplantiEkiSchema),
    /** Madde 230 — kaldırılan nüshaların izi (kim · ne zaman · gerekçe). */
    silinenEkler: zod_1.z.array(kapi_durumu_1.silinenEkSchema),
    kirkSekizSaatUyarisi: zod_1.z.boolean(),
    yetkiler: exports.toplantiYetkileriSchema,
});
exports.toplantiListesiSchema = zod_1.z.object({
    satirlar: zod_1.z.array(exports.toplantiOzetiSchema),
    toplam: zod_1.z.number().int().nonnegative(),
    sayfa: zod_1.z.number().int().positive(),
    sayfaBoyutu: zod_1.z.number().int().positive(),
});
exports.toplantiListeSuzgeciSchema = zod_1.z.object({
    tip: exports.kurulToplantiTipiSchema.optional(),
    durum: exports.kurulToplantiDurumuSchema.optional(),
    tarihBaslangic: zod_1.z.iso.date().optional(),
    tarihBitis: zod_1.z.iso.date().optional(),
    sayfa: zod_1.z.coerce.number().int().positive().default(1),
    sayfaBoyutu: zod_1.z.coerce.number().int().positive().max(100).default(25),
});
/** Çıktı antetindeki süzgeç özeti — ekran ve Excel AYNI metni okur (P4). */
function toplantiSuzgecOzeti(s) {
    const kalemler = [];
    if (s.tip)
        kalemler.push(`Tip: ${exports.KURUL_TOPLANTI_TIP_ETIKETI[s.tip]}`);
    if (s.durum)
        kalemler.push(`Durum: ${exports.KURUL_TOPLANTI_DURUM_ETIKETI[s.durum]}`);
    if (s.tarihBaslangic || s.tarihBitis) {
        kalemler.push(`Tarih: ${s.tarihBaslangic ?? '…'} – ${s.tarihBitis ?? '…'}`);
    }
    return kalemler.length > 0 ? kalemler : ['Süzgeç yok — tüm kayıtlar'];
}
/** Kurul açma ekranının seçenekleri — bahçeden (ikinci filtre yazılmaz). */
exports.kurulSecenekleriSchema = zod_1.z.object({
    isyerleri: zod_1.z.array(zod_1.z.object({
        id: zod_1.z.uuid(),
        ad: zod_1.z.string().min(1),
        companyAd: zod_1.z.string().min(1),
        tehlikeSinifi: zod_1.z.enum(['low_risk', 'hazardous', 'highly_hazardous']),
        calisanSayisi: zod_1.z.number().int().nonnegative(),
        kurulVar: zod_1.z.boolean(),
    })),
});
/**
 * C6 — *"Kurul gündemine ekle"* düğmesinin TEK yüklemi (§2.40): kurul yoksa
 * düğme görünmez (`kurulId` null), planlı toplantı yoksa pasif + sebep.
 */
exports.gundemSecenekleriSchema = zod_1.z.object({
    kurulId: zod_1.z.uuid().nullable(),
    ekleyebilir: zod_1.z.boolean(),
    engel: zod_1.z.string().nullable(),
    toplantilar: zod_1.z.array(zod_1.z.object({ id: zod_1.z.uuid(), takipNo: zod_1.z.string().min(1), tarih: zod_1.z.iso.date() })),
});
//# sourceMappingURL=kurul.js.map